import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What age can my child start?',
  answer: 'We accept students as young as 3 years old in our Mini Troopers program.'
}, {
  question: 'Does my child need experience?',
  answer: 'No! Most of our students start as complete beginners.'
}, {
  question: 'Do I need to buy a uniform for the trial?',
  answer: 'No gear is needed for the trial. Just wear comfortable athletic clothes.'
}, {
  question: 'How do I schedule the first class?',
  answer: 'Fill out the form, and we will call or text you to find a time that works for your schedule.'
}];
export function StartFreeFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-3083" />;
}